import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';

import Cookies from '@r1-frontend/shared/helpers/Cookies';

import { closeCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { changeCity } from '~/src/components/CitySelectContainer/store/actions/changeCity';
import { CITYDOMAIN_COOKIE, COOKIE_MAX_AGE_LONG } from '~/src/constants';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { setIsAuth } from '~/src/store/actionCreators/auth';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const saveCity = (selectedCity?: ICitySatellite) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const { auth: { isAuth } } = state;
        const providerId = selectProviderId(state);

        if (selectedCity) {
            const { domain, provider_id } = selectedCity;
            if (provider_id !== providerId) {
                const cookies = new Cookies();
                cookies.save({
                    name: CITYDOMAIN_COOKIE,
                    value: domain,
                    config: { maxAge: COOKIE_MAX_AGE_LONG },
                });

                dispatch(setIsAuth(false));
                changeCity(domain, provider_id, isAuth);
            }
        }

        dispatch(closeCitySelect());
    };
};

export default saveCity;
